export default __webpack_public_path__ + "static/media/Frostspike.e7d1f687.jpg";